const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);
const LOCAL_ENVIRONMENTS = new Set(["local", "dev", "development"]);

export const isTruthyFlag = (value) =>
  TRUE_VALUES.has(String(value || "").trim().toLowerCase());

export const isLocalOrDevEnvironment = (env = process.env) => {
  const configuredEnvironment = env.REACT_APP_ENVIRONMENT || env.NODE_ENV;
  return LOCAL_ENVIRONMENTS.has(
    String(configuredEnvironment || "").trim().toLowerCase(),
  );
};

// registration is local-only: dev and canary are shared environments, prod is public
export const isRegistrationEnabled = (env = process.env) =>
  String(env.REACT_APP_ENVIRONMENT || env.NODE_ENV || "").trim().toLowerCase() === "local";

export const isRangeFinderFeatureEnabled = () => false;

export const isInstrumentTypeFilterEnabled = (env = process.env) =>
  isTruthyFlag(env.REACT_APP_ENABLE_INSTRUMENT_TYPE_FILTER);
